import * as common from './fr.json';

const allFr = {
  common,
};

export default allFr;
